import { BcAntenatalRadioTextboxField } from "../BcAntenatalRadioTextboxField";
import { MedicalHistoryCardiovascular } from "./Section7/MedicalHistoryCardiovascular";
import { MedicalHistoryEndocrine } from "./Section7/MedicalHistoryEndocrine";
import { MedicalHistoryImmunizations } from "./Section7/MedicalHistoryImmunizations";
import { MedicalHistoryInfectiousDiseases } from "./Section7/MedicalHistoryInfectiousDiseases";
import { MedicalHistoryMentalHealth } from "./Section7/MedicalHistoryMentalHealth";

class BritishColumbiaObstetricalFileMedicalHistory {
    public Surgery: BcAntenatalRadioTextboxField;
    public AnestheticComplications: BcAntenatalRadioTextboxField;
    public Neuro: BcAntenatalRadioTextboxField;
    public Respiratory: BcAntenatalRadioTextboxField;
    public Cardiovascular: MedicalHistoryCardiovascular;
    public AbdominalGastrointestinal: BcAntenatalRadioTextboxField;
    public GynoGenitourinary: BcAntenatalRadioTextboxField;
    public Hematology: BcAntenatalRadioTextboxField;
    public Other: BcAntenatalRadioTextboxField;
    public Endocrine: MedicalHistoryEndocrine;
    public MentalHealth: MedicalHistoryMentalHealth;
    public InfectiousDiseases: MedicalHistoryInfectiousDiseases;
    public Immunizations: MedicalHistoryImmunizations;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileMedicalHistory>) {
        Object.assign(this, fields);

        this.Surgery = new BcAntenatalRadioTextboxField(fields?.Surgery);
        this.AnestheticComplications = new BcAntenatalRadioTextboxField(fields?.AnestheticComplications);
        this.Neuro = new BcAntenatalRadioTextboxField(fields?.Neuro);
        this.Respiratory = new BcAntenatalRadioTextboxField(fields?.Respiratory);
        this.AbdominalGastrointestinal = new BcAntenatalRadioTextboxField(fields?.AbdominalGastrointestinal);
        this.GynoGenitourinary = new BcAntenatalRadioTextboxField(fields?.GynoGenitourinary);
        this.Hematology = new BcAntenatalRadioTextboxField(fields?.Hematology);
        this.Other = new BcAntenatalRadioTextboxField(fields?.Other);
        this.Cardiovascular = new MedicalHistoryCardiovascular(fields?.Cardiovascular);
        this.Endocrine = new MedicalHistoryEndocrine(fields?.Endocrine);
        this.MentalHealth = new MedicalHistoryMentalHealth(fields?.MentalHealth);
        this.InfectiousDiseases = new MedicalHistoryInfectiousDiseases(fields?.InfectiousDiseases);
        this.Immunizations = new MedicalHistoryImmunizations(fields?.Immunizations);
    }

    public setEmptyFieldsAsNo(): void {
        this.Surgery.Value ??= false;
        this.AnestheticComplications.Value ??= false;
        this.Neuro.Value ??= false;
        this.Respiratory.Value ??= false;
        this.Other.Value ??= false;
        this.AbdominalGastrointestinal.Value ??= false;
        this.GynoGenitourinary.Value ??= false;
        this.Hematology.Value ??= false;
        this.Cardiovascular.HasCardiovascular ??= false;
        this.Endocrine.HasEndocrine ??= false;
        this.MentalHealth.HasMentalHealth ??= false;
        this.InfectiousDiseases.HasInfectiousDiseases ??= false;
        this.Immunizations.HasImmunizations ??= false;
    }
}

export { BritishColumbiaObstetricalFileMedicalHistory };
